export const REFUND_QUOTE_STRINGS: Record<string, [string, string, string]> = {
  'rq.reason.ecpay_automation_disabled': [
    '原付款通道尚未開放自動退款，請洽櫃檯協助。',
    'Automatic refunds are not enabled for the original payment method. Please ask staff.',
    '元の決済方法では自動返金が有効になっていません。窓口へご相談ください。',
  ],
  'rq.reason.newebpay_automation_disabled': [
    '原付款通道尚未開放自動退款，請洽櫃檯協助。',
    'Automatic refunds are not enabled for the original payment method. Please ask staff.',
    '元の決済方法では自動返金が有効になっていません。窓口へご相談ください。',
  ],
  'rq.reason.gateway_not_configured': [
    '原付款通道目前無法自動退款，請洽櫃檯協助。',
    'Automatic refunds are unavailable for the original payment method. Please ask staff.',
    '元の決済方法で自動返金できません。窓口へご相談ください。',
  ],
  'rq.reason.amount_over_auto_cap': [
    '退款金額超過自動處理上限，需由櫃檯人工確認。',
    'The refund exceeds the automatic processing limit and requires staff review.',
    '返金額が自動処理の上限を超えているため、窓口での確認が必要です。',
  ],
  'rq.reviewTitle': ['確認申請退票', 'Review refund application', '払い戻し申請の確認'],
  'rq.continue': [
    '下一步：確認退票資訊',
    'Next: review refund details',
    '次へ：払い戻し内容の確認',
  ],
  'rq.edit': ['返回修改', 'Edit details', '入力内容を修正'],
  'rq.submit': ['正式送出申請', 'Submit application', '申請を送信'],
  'rq.submitUnavailable': [
    '線上送出尚未開放，請洽現場服務人員。',
    'Online submission is not yet available. Please ask staff for assistance.',
    'オンライン申請はまだご利用いただけません。係員へご相談ください。',
  ],
  'rq.prepareHint': [
    '請選擇退票原因並勾選同意事項，再確認退票資訊。',
    'Select a reason and check the agreement before reviewing your refund details.',
    '理由を選択し、同意事項にチェックしてから払い戻し内容をご確認ください。',
  ],
  'rq.eligible': ['符合申請條件', 'Eligible to apply', '申請条件を満たしています'],
  'rq.manual_review': ['需由櫃檯人工確認', 'Staff review required', '窓口での確認が必要です'],
  'rq.ineligible': [
    '目前無法自助退票',
    'Self-service refund unavailable',
    '現在、端末で払い戻しできません',
  ],
  'rq.note': [
    '目前僅提供資格與金額試算，尚未提出申請，也尚未退款。',
    'This is an estimate only. No application has been submitted and no refund paid.',
    '条件と金額の試算のみです。申請・返金はまだ行われていません。',
  ],
  'rq.estimate': ['預計退款金額', 'Estimated refund', '返金見込額'],
  'rq.ticket': ['票券計算金額', 'Ticket calculation amount', '計算対象の券面額'],
  'rq.ratio': ['政策退款比例', 'Policy refund ratio', '規定の返金率'],
  'rq.policyFee': ['政策設定固定費用', 'Configured fixed fee', '規定の固定手数料'],
  'rq.ratioFee': ['比例實際扣除', 'Actual ratio deduction', '返金率による控除額'],
  'rq.actualFee': ['固定費用實際扣除', 'Actual fixed fee deduction', '実際の固定手数料控除額'],
  'rq.total': ['實際扣除合計', 'Total actual deduction', '実際の控除合計'],
  'rq.time': ['試算時間', 'Calculated at', '試算日時'],
  'rq.unavailable': ['無法試算', 'Unavailable', '試算できません'],
  'rq.capped': [
    '實際扣除已限制在票券金額內，無須額外補繳。',
    'Actual deductions are capped at the ticket amount. No additional payment is due.',
    '控除額は券面額が上限です。追加のお支払いは不要です。',
  ],
  'rq.allocated': [
    '以上使用這張票購買時的分攤金額，並非整套票價；人工確認後金額可能不同。',
    'This uses the scanned ticket’s allocated purchase amount, not the full package price. Staff review may change the amount.',
    'この券の購入時の配分額で、セット全体の価格ではありません。窓口での確認後に金額が変わる場合があります。',
  ],
  'rq.manualNote': [
    '金額僅供參考，請攜带票券洽服務櫃檯；尚未核准退款。',
    'This amount is an estimate. Bring your ticket to the service counter; no refund has been approved.',
    '金額は目安です。チケットを窓口へお持ちください。返金はまだ承認されていません。',
  ],
  'rq.reason.existing_refund': [
    '已有退票申請，請查詢退款進度或洽櫃檯。',
    'A refund request already exists. Check progress or ask staff.',
    '払い戻し申請があります。状況を確認するか窓口へご相談ください。',
  ],
  'rq.reason.ticket_invalid': [
    '此票券狀態不符合退票申請條件。',
    'This ticket state does not allow a refund application.',
    'このチケットの状態では払い戻しを申請できません。',
  ],
  'rq.reason.policy_missing': [
    '目前沒有可用的退票政策，無法試算，請洽櫃檯。',
    'No active refund policy is available. Please ask staff.',
    '適用できる規定がないため試算できません。窓口へご相談ください。',
  ],
  'rq.reason.window_closed': [
    '已超過適用政策的退票期限。',
    'The refund deadline has passed.',
    '適用規定の払い戻し期限を過ぎています。',
  ],
  'rq.reason.package': [
    '此票券屬於套票，可在此送出本張票券的退票申請，由櫃檯人工審核完整行程。如需退其他段票券，請逐張掃描申請。',
    'You may submit this package ticket for staff review of the full itinerary. Scan each other ticket separately to request its refund.',
    'このセット券の払い戻しを申請できます。窓口で全行程を確認します。他の区間券も払い戻す場合は、1枚ずつ読み取って申請してください。',
  ],
  'rq.reason.used_ticket': [
    '票券已使用，需由櫃檯確認退票資格。',
    'This ticket has been used. Staff must review eligibility.',
    '使用済みのチケットです。窓口で条件をご確認ください。',
  ],
  'rq.reason.no_captured_payment': [
    '查無已收款交易，需由櫃檯確認付款情形。',
    'No captured payment was found. Staff must check payment.',
    '支払完了の記録がありません。窓口で支払状況をご確認ください。',
  ],
  'rq.reason.provider_not_refundable': [
    '原付款方式需由櫃檯處理退款。',
    'The original payment method requires staff assistance.',
    '元の決済方法では窓口での返金手続きが必要です。',
  ],
};
